import { createApp } from 'vue'
import MessageComponent from './index.vue'

let instance = null
let app = null
let container = null

function destroy() {
  if (!app) return
  app.unmount()
  if (container && container.parentNode) {
    container.parentNode.removeChild(container)
  }
  app = null
  instance = null
  container = null
}

function getInstance() {
  if (instance) return instance

  container = document.createElement('div')
  document.body.appendChild(container)
  app = createApp(MessageComponent)
  instance = app.mount(container)
  instance.setOnEmpty(destroy)
  return instance
}

function createMessage(type) {
  return (text, duration) => getInstance().add(text, type, duration)
}

const Message = {
  success: createMessage('success'),
  warning: createMessage('warning'),
  error: createMessage('error'),
  info: createMessage('info')
}

export default Message
